import { render, staticRenderFns } from "./numeric-score-entry.vue?vue&type=template&id=f5dfc370&scoped=true"
import script from "./numeric-score-entry.vue?vue&type=script&lang=js"
export * from "./numeric-score-entry.vue?vue&type=script&lang=js"
import style0 from "./numeric-score-entry.vue?vue&type=style&index=0&id=f5dfc370&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dfc370",
  null
  
)

export default component.exports